const EU_MEMBER_COUNTRY_CODES = new Set([
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
]);

const countryEntries = [
  { countryCode: "AF", label_fr: "Afghanistan" },
  { countryCode: "ZA", label_fr: "Afrique du Sud" },
  { countryCode: "AL", label_fr: "Albanie" },
  { countryCode: "DZ", label_fr: "Algérie" },
  { countryCode: "DE", label_fr: "Allemagne" },
  { countryCode: "AD", label_fr: "Andorre" },
  { countryCode: "AO", label_fr: "Angola" },
  { countryCode: "AI", label_fr: "Anguilla" },
  { countryCode: "AQ", label_fr: "Antarctique" },
  { countryCode: "AG", label_fr: "Antigua-et-Barbuda" },
  { countryCode: "AN", label_fr: "Antilles néerlandaises" },
  { countryCode: "SA", label_fr: "Arabie saoudite" },
  { countryCode: "AR", label_fr: "Argentine" },
  { countryCode: "AM", label_fr: "Arménie" },
  { countryCode: "AW", label_fr: "Aruba" },
  { countryCode: "AU", label_fr: "Australie" },
  { countryCode: "AT", label_fr: "Autriche" },
  { countryCode: "AZ", label_fr: "Azerbaïdjan" },
  { countryCode: "BS", label_fr: "Bahamas" },
  { countryCode: "BH", label_fr: "Bahreïn" },
  { countryCode: "BD", label_fr: "Bangladesh" },
  { countryCode: "BB", label_fr: "Barbade" },
  { countryCode: "BY", label_fr: "Bélarus" },
  { countryCode: "BE", label_fr: "Belgique" },
  { countryCode: "BZ", label_fr: "Belize" },
  { countryCode: "BJ", label_fr: "Bénin" },
  { countryCode: "BM", label_fr: "Bermudes" },
  { countryCode: "BT", label_fr: "Bhoutan" },
  { countryCode: "BO", label_fr: "Bolivie" },
  { countryCode: "BA", label_fr: "Bosnie-Herzégovine" },
  { countryCode: "BW", label_fr: "Botswana" },
  { countryCode: "BR", label_fr: "Brésil" },
  { countryCode: "BN", label_fr: "Brunéi Darussalam" },
  { countryCode: "BG", label_fr: "Bulgarie" },
  { countryCode: "BF", label_fr: "Burkina Faso" },
  { countryCode: "BI", label_fr: "Burundi" },
  { countryCode: "KH", label_fr: "Cambodge" },
  { countryCode: "CM", label_fr: "Cameroun" },
  { countryCode: "CA", label_fr: "Canada" },
  { countryCode: "CV", label_fr: "Cap-Vert" },
  { countryCode: "EA", label_fr: "Ceuta et Melilla" },
  { countryCode: "CL", label_fr: "Chili" },
  { countryCode: "CN", label_fr: "Chine" },
  { countryCode: "CY", label_fr: "Chypre" },
  { countryCode: "CO", label_fr: "Colombie" },
  { countryCode: "KM", label_fr: "Comores" },
  { countryCode: "CG", label_fr: "Congo-Brazzaville" },
  { countryCode: "KP", label_fr: "Corée du Nord" },
  { countryCode: "KR", label_fr: "Corée du Sud" },
  { countryCode: "CR", label_fr: "Costa Rica" },
  { countryCode: "CI", label_fr: "Côte d’Ivoire" },
  { countryCode: "HR", label_fr: "Croatie" },
  { countryCode: "CU", label_fr: "Cuba" },
  { countryCode: "DK", label_fr: "Danemark" },
  { countryCode: "DG", label_fr: "Diego Garcia" },
  { countryCode: "DJ", label_fr: "Djibouti" },
  { countryCode: "DM", label_fr: "Dominique" },
  { countryCode: "EG", label_fr: "Égypte" },
  { countryCode: "SV", label_fr: "El Salvador" },
  { countryCode: "AE", label_fr: "Émirats arabes unis" },
  { countryCode: "EC", label_fr: "Équateur" },
  { countryCode: "ER", label_fr: "Érythrée" },
  { countryCode: "ES", label_fr: "Espagne" },
  { countryCode: "EE", label_fr: "Estonie" },
  { countryCode: "VA", label_fr: "État de la Cité du Vatican" },
  { countryCode: "FM", label_fr: "États fédérés de Micronésie" },
  { countryCode: "US", label_fr: "États-Unis" },
  { countryCode: "ET", label_fr: "Éthiopie" },
  { countryCode: "FJ", label_fr: "Fidji" },
  { countryCode: "FI", label_fr: "Finlande" },
  { countryCode: "FR", label_fr: "France" },
  { countryCode: "GA", label_fr: "Gabon" },
  { countryCode: "GM", label_fr: "Gambie" },
  { countryCode: "GE", label_fr: "Géorgie" },
  { countryCode: "GS", label_fr: "Géorgie du Sud et les îles Sandwich du Sud" },
  { countryCode: "GH", label_fr: "Ghana" },
  { countryCode: "GI", label_fr: "Gibraltar" },
  { countryCode: "GR", label_fr: "Grèce" },
  { countryCode: "GD", label_fr: "Grenade" },
  { countryCode: "GL", label_fr: "Groenland" },
  { countryCode: "GP", label_fr: "Guadeloupe" },
  { countryCode: "GU", label_fr: "Guam" },
  { countryCode: "GT", label_fr: "Guatemala" },
  { countryCode: "GG", label_fr: "Guernesey" },
  { countryCode: "GN", label_fr: "Guinée" },
  { countryCode: "GQ", label_fr: "Guinée équatoriale" },
  { countryCode: "GW", label_fr: "Guinée-Bissau" },
  { countryCode: "GY", label_fr: "Guyana" },
  { countryCode: "GF", label_fr: "Guyane française" },
  { countryCode: "HT", label_fr: "Haïti" },
  { countryCode: "HN", label_fr: "Honduras" },
  { countryCode: "HU", label_fr: "Hongrie" },
  { countryCode: "BV", label_fr: "Île Bouvet" },
  { countryCode: "CX", label_fr: "Île Christmas" },
  { countryCode: "CP", label_fr: "Île Clipperton" },
  { countryCode: "AC", label_fr: "Île de l'Ascension" },
  { countryCode: "IM", label_fr: "Île de Man" },
  { countryCode: "NF", label_fr: "Île Norfolk" },
  { countryCode: "AX", label_fr: "Îles Åland" },
  { countryCode: "KY", label_fr: "Îles Caïmans" },
  { countryCode: "IC", label_fr: "Îles Canaries" },
  { countryCode: "CC", label_fr: "Îles Cocos - Keeling" },
  { countryCode: "CK", label_fr: "Îles Cook" },
  { countryCode: "FO", label_fr: "Îles Féroé" },
  { countryCode: "HM", label_fr: "Îles Heard et MacDonald" },
  { countryCode: "FK", label_fr: "Îles Malouines" },
  { countryCode: "MP", label_fr: "Îles Mariannes du Nord" },
  { countryCode: "MH", label_fr: "Îles Marshall" },
  { countryCode: "UM", label_fr: "Îles Mineures Éloignées des États-Unis" },
  { countryCode: "SB", label_fr: "Îles Salomon" },
  { countryCode: "TC", label_fr: "Îles Turks et Caïques" },
  { countryCode: "VG", label_fr: "Îles Vierges britanniques" },
  { countryCode: "VI", label_fr: "Îles Vierges des États-Unis" },
  { countryCode: "IN", label_fr: "Inde" },
  { countryCode: "ID", label_fr: "Indonésie" },
  { countryCode: "IQ", label_fr: "Irak" },
  { countryCode: "IR", label_fr: "Iran" },
  { countryCode: "IE", label_fr: "Irlande" },
  { countryCode: "IS", label_fr: "Islande" },
  { countryCode: "IL", label_fr: "Israël" },
  { countryCode: "IT", label_fr: "Italie" },
  { countryCode: "JM", label_fr: "Jamaïque" },
  { countryCode: "JP", label_fr: "Japon" },
  { countryCode: "JE", label_fr: "Jersey" },
  { countryCode: "JO", label_fr: "Jordanie" },
  { countryCode: "KZ", label_fr: "Kazakhstan" },
  { countryCode: "KE", label_fr: "Kenya" },
  { countryCode: "KG", label_fr: "Kirghizistan" },
  { countryCode: "KI", label_fr: "Kiribati" },
  { countryCode: "KW", label_fr: "Koweït" },
  { countryCode: "LA", label_fr: "Laos" },
  { countryCode: "LS", label_fr: "Lesotho" },
  { countryCode: "LV", label_fr: "Lettonie" },
  { countryCode: "LB", label_fr: "Liban" },
  { countryCode: "LR", label_fr: "Libéria" },
  { countryCode: "LY", label_fr: "Libye" },
  { countryCode: "LI", label_fr: "Liechtenstein" },
  { countryCode: "LT", label_fr: "Lituanie" },
  { countryCode: "LU", label_fr: "Luxembourg" },
  { countryCode: "MK", label_fr: "Macédoine" },
  { countryCode: "MG", label_fr: "Madagascar" },
  { countryCode: "MY", label_fr: "Malaisie" },
  { countryCode: "MW", label_fr: "Malawi" },
  { countryCode: "MV", label_fr: "Maldives" },
  { countryCode: "ML", label_fr: "Mali" },
  { countryCode: "MT", label_fr: "Malte" },
  { countryCode: "MA", label_fr: "Maroc" },
  { countryCode: "MQ", label_fr: "Martinique" },
  { countryCode: "MU", label_fr: "Maurice" },
  { countryCode: "MR", label_fr: "Mauritanie" },
  { countryCode: "YT", label_fr: "Mayotte" },
  { countryCode: "MX", label_fr: "Mexique" },
  { countryCode: "MD", label_fr: "Moldavie" },
  { countryCode: "MC", label_fr: "Monaco" },
  { countryCode: "MN", label_fr: "Mongolie" },
  { countryCode: "ME", label_fr: "Monténégro" },
  { countryCode: "MS", label_fr: "Montserrat" },
  { countryCode: "MZ", label_fr: "Mozambique" },
  { countryCode: "MM", label_fr: "Myanmar" },
  { countryCode: "NA", label_fr: "Namibie" },
  { countryCode: "NR", label_fr: "Nauru" },
  { countryCode: "NP", label_fr: "Népal" },
  { countryCode: "NI", label_fr: "Nicaragua" },
  { countryCode: "NE", label_fr: "Niger" },
  { countryCode: "NG", label_fr: "Nigéria" },
  { countryCode: "NU", label_fr: "Niue" },
  { countryCode: "NO", label_fr: "Norvège" },
  { countryCode: "NC", label_fr: "Nouvelle-Calédonie" },
  { countryCode: "NZ", label_fr: "Nouvelle-Zélande" },
  { countryCode: "OM", label_fr: "Oman" },
  { countryCode: "UG", label_fr: "Ouganda" },
  { countryCode: "UZ", label_fr: "Ouzbékistan" },
  { countryCode: "PK", label_fr: "Pakistan" },
  { countryCode: "PW", label_fr: "Palaos" },
  { countryCode: "PA", label_fr: "Panama" },
  { countryCode: "PG", label_fr: "Papouasie-Nouvelle-Guinée" },
  { countryCode: "PY", label_fr: "Paraguay" },
  { countryCode: "NL", label_fr: "Pays-Bas" },
  { countryCode: "PE", label_fr: "Pérou" },
  { countryCode: "PH", label_fr: "Philippines" },
  { countryCode: "PN", label_fr: "Pitcairn" },
  { countryCode: "PL", label_fr: "Pologne" },
  { countryCode: "PF", label_fr: "Polynésie française" },
  { countryCode: "PR", label_fr: "Porto Rico" },
  { countryCode: "PT", label_fr: "Portugal" },
  { countryCode: "QA", label_fr: "Qatar" },
  { countryCode: "HK", label_fr: "R.A.S. chinoise de Hong Kong" },
  { countryCode: "MO", label_fr: "R.A.S. chinoise de Macao" },
  { countryCode: "QO", label_fr: "régions éloignées de l’Océanie" },
  { countryCode: "CF", label_fr: "République centrafricaine" },
  { countryCode: "CD", label_fr: "République démocratique du Congo" },
  { countryCode: "DO", label_fr: "République dominicaine" },
  { countryCode: "CZ", label_fr: "République tchèque" },
  { countryCode: "RE", label_fr: "Réunion" },
  { countryCode: "RO", label_fr: "Roumanie" },
  { countryCode: "GB", label_fr: "Royaume-Uni" },
  { countryCode: "RU", label_fr: "Russie" },
  { countryCode: "RW", label_fr: "Rwanda" },
  { countryCode: "EH", label_fr: "Sahara occidental" },
  { countryCode: "BL", label_fr: "Saint-Barthélémy" },
  { countryCode: "KN", label_fr: "Saint-Kitts-et-Nevis" },
  { countryCode: "SM", label_fr: "Saint-Marin" },
  { countryCode: "MF", label_fr: "Saint-Martin" },
  { countryCode: "PM", label_fr: "Saint-Pierre-et-Miquelon" },
  { countryCode: "VC", label_fr: "Saint-Vincent-et-les Grenadines" },
  { countryCode: "SH", label_fr: "Sainte-Hélène" },
  { countryCode: "LC", label_fr: "Sainte-Lucie" },
  { countryCode: "WS", label_fr: "Samoa" },
  { countryCode: "AS", label_fr: "Samoa américaines" },
  { countryCode: "ST", label_fr: "Sao Tomé-et-Principe" },
  { countryCode: "SN", label_fr: "Sénégal" },
  { countryCode: "RS", label_fr: "Serbie" },
  { countryCode: "CS", label_fr: "Serbie-et-Monténégro" },
  { countryCode: "SC", label_fr: "Seychelles" },
  { countryCode: "SL", label_fr: "Sierra Leone" },
  { countryCode: "SG", label_fr: "Singapour" },
  { countryCode: "SK", label_fr: "Slovaquie" },
  { countryCode: "SI", label_fr: "Slovénie" },
  { countryCode: "SO", label_fr: "Somalie" },
  { countryCode: "SD", label_fr: "Soudan" },
  { countryCode: "LK", label_fr: "Sri Lanka" },
  { countryCode: "SE", label_fr: "Suède" },
  { countryCode: "CH", label_fr: "Suisse" },
  { countryCode: "SR", label_fr: "Suriname" },
  { countryCode: "SJ", label_fr: "Svalbard et Île Jan Mayen" },
  { countryCode: "SZ", label_fr: "Swaziland" },
  { countryCode: "SY", label_fr: "Syrie" },
  { countryCode: "TJ", label_fr: "Tadjikistan" },
  { countryCode: "TW", label_fr: "Taïwan" },
  { countryCode: "TZ", label_fr: "Tanzanie" },
  { countryCode: "TD", label_fr: "Tchad" },
  { countryCode: "TF", label_fr: "Terres australes françaises" },
  { countryCode: "IO", label_fr: "Territoire britannique de l'océan Indien" },
  { countryCode: "PS", label_fr: "Territoire palestinien" },
  { countryCode: "TH", label_fr: "Thaïlande" },
  { countryCode: "TL", label_fr: "Timor oriental" },
  { countryCode: "TG", label_fr: "Togo" },
  { countryCode: "TK", label_fr: "Tokelau" },
  { countryCode: "TO", label_fr: "Tonga" },
  { countryCode: "TT", label_fr: "Trinité-et-Tobago" },
  { countryCode: "TA", label_fr: "Tristan da Cunha" },
  { countryCode: "TN", label_fr: "Tunisie" },
  { countryCode: "TM", label_fr: "Turkménistan" },
  { countryCode: "TR", label_fr: "Turquie" },
  { countryCode: "TV", label_fr: "Tuvalu" },
  { countryCode: "UA", label_fr: "Ukraine" },
  { countryCode: "EU", label_fr: "Union européenne" },
  { countryCode: "UY", label_fr: "Uruguay" },
  { countryCode: "VU", label_fr: "Vanuatu" },
  { countryCode: "VE", label_fr: "Venezuela" },
  { countryCode: "VN", label_fr: "Viêt Nam" },
  { countryCode: "WF", label_fr: "Wallis-et-Futuna" },
  { countryCode: "YE", label_fr: "Yémen" },
  { countryCode: "ZM", label_fr: "Zambie" },
  { countryCode: "ZW", label_fr: "Zimbabe" },
];

export type Country = {
  countryCode: string;
  label_fr: string;
  isEu: boolean;
};

export const countries: Country[] = countryEntries.map((country) => ({
  ...country,
  isEu: EU_MEMBER_COUNTRY_CODES.has(country.countryCode),
}));

export const isEuropeanUnionCountry = (countryCode: string): boolean =>
  EU_MEMBER_COUNTRY_CODES.has(countryCode);

export type RegionCode =
  | "EU"
  | "EUROPE_NON_EU"
  | "NORTH_AMERICA"
  | "LATIN_AMERICA"
  | "AFRICA"
  | "MIDDLE_EAST"
  | "ASIA"
  | "OCEANIA";

export const COUNTRY_REGIONS: Record<RegionCode, string[]> = {
  EU: [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK",
  ],
  EUROPE_NON_EU: [
    "AD",
    "AL",
    "AM",
    "AX",
    "AZ",
    "BA",
    "BY",
    "CH",
    "CS",
    "FO",
    "GB",
    "GE",
    "GG",
    "GI",
    "IM",
    "IS",
    "JE",
    "LI",
    "MC",
    "MD",
    "ME",
    "MK",
    "NO",
    "RS",
    "RU",
    "SJ",
    "SM",
    "TR",
    "UA",
    "VA",
  ],
  NORTH_AMERICA: ["BM", "CA", "GL", "MX", "PM", "US"],
  LATIN_AMERICA: [
    "AG",
    "AI",
    "AN",
    "AR",
    "AW",
    "BB",
    "BL",
    "BO",
    "BR",
    "BS",
    "BZ",
    "CL",
    "CO",
    "CR",
    "CU",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GP",
    "GF",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "NI",
    "PA",
    "PE",
    "PR",
    "PY",
    "SR",
    "SV",
    "TC",
    "TT",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI",
  ],
  AFRICA: [
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "DZ",
    "EA",
    "EG",
    "EH",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IC",
    "KE",
    "KM",
    "LR",
    "LS",
    "LY",
    "MA",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SD",
    "SH",
    "SL",
    "SN",
    "SO",
    "ST",
    "SZ",
    "TA",
    "TD",
    "TG",
    "TN",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW",
  ],
  MIDDLE_EAST: ["AE", "BH", "IL", "IQ", "IR", "JO", "KW", "LB", "OM", "PS", "QA", "SA", "SY", "YE"],
  ASIA: [
    "AF",
    "BD",
    "BN",
    "BT",
    "CN",
    "HK",
    "ID",
    "IN",
    "JP",
    "KG",
    "KH",
    "KP",
    "KR",
    "KZ",
    "LA",
    "LK",
    "MM",
    "MN",
    "MO",
    "MV",
    "MY",
    "NP",
    "PH",
    "PK",
    "SG",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TW",
    "UZ",
    "VN",
  ],
  OCEANIA: [
    "AS",
    "AU",
    "CC",
    "CK",
    "CX",
    "FJ",
    "FM",
    "GU",
    "HM",
    "KI",
    "MH",
    "MP",
    "NC",
    "NF",
    "NR",
    "NU",
    "NZ",
    "PF",
    "PG",
    "PN",
    "PW",
    "QO",
    "SB",
    "TK",
    "TO",
    "TV",
    "VU",
    "WF",
    "WS",
  ],
};

export const REGION_LABELS: Record<RegionCode, string> = {
  EU: "UE",
  EUROPE_NON_EU: "Europe hors UE",
  NORTH_AMERICA: "Amérique du Nord",
  LATIN_AMERICA: "Amérique latine",
  AFRICA: "Afrique",
  MIDDLE_EAST: "Moyen-Orient",
  ASIA: "Asie",
  OCEANIA: "Océanie",
};
